import CakeIcon from '@mui/icons-material/Cake';
import StarIcon from '@mui/icons-material/Star';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Filter5Icon from '@mui/icons-material/Filter5';
import SmsIcon from '@mui/icons-material/Sms';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ContactsIcon from '@mui/icons-material/Contacts';
import PermContactCalendarRoundedIcon from '@mui/icons-material/PermContactCalendarRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import TrackChangesRoundedIcon from '@mui/icons-material/TrackChangesRounded';
import WavingHandRoundedIcon from '@mui/icons-material/WavingHandRounded';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import ManageHistoryRoundedIcon from '@mui/icons-material/ManageHistoryRounded';
import EventRepeatRoundedIcon from '@mui/icons-material/EventRepeatRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import AttributionRoundedIcon from '@mui/icons-material/AttributionRounded';
import FactoryRoundedIcon from '@mui/icons-material/FactoryRounded';
import PersonSearchRoundedIcon from '@mui/icons-material/PersonSearchRounded';
import AddLinkRoundedIcon from '@mui/icons-material/AddLinkRounded';
import ConnectWithoutContactRoundedIcon from '@mui/icons-material/ConnectWithoutContactRounded';
import CallMadeRoundedIcon from '@mui/icons-material/CallMadeRounded';
import CallReceivedRoundedIcon from '@mui/icons-material/CallReceivedRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import ViewKanbanRoundedIcon from '@mui/icons-material/ViewKanbanRounded';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import StairsRoundedIcon from '@mui/icons-material/StairsRounded';
import AlarmOnRoundedIcon from '@mui/icons-material/AlarmOnRounded';
import FreeCancellationRoundedIcon from '@mui/icons-material/FreeCancellationRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import SsidChartRoundedIcon from '@mui/icons-material/SsidChartRounded';
import TroubleshootRoundedIcon from '@mui/icons-material/TroubleshootRounded';

//icons linked to sections/routes
export const ICONS = {
  PRIORITIES: AlarmOnRoundedIcon,
  REDEMPTION: EmojiEventsRoundedIcon,
  ROLLINGREDEMPTIONREPORT: SsidChartRoundedIcon,
  REDEMPTIONREPORT: TroubleshootRoundedIcon,
  APPOINTMENTSREPORT: FreeCancellationRoundedIcon,
  FUNNELREPORT: FilterListRoundedIcon,
  KANBAN: ViewKanbanRoundedIcon,
  REPORT: QueryStatsRoundedIcon,
  WAVEACTIVITIESREPORT: DashboardRoundedIcon,
  OUTBOUNDCALLSANALYSIS: CallMadeRoundedIcon,
  INBOUNDCALLSANALYSIS: CallReceivedRoundedIcon,
  CUSTOMERS: ContactsIcon,
  LEADS_MANAGEMENT: ConnectWithoutContactRoundedIcon,
  LEADS: PersonSearchRoundedIcon,
  LEAD_ORIGINS: AddLinkRoundedIcon,
  BIRTHDAYS: CakeIcon,
  LIGHT: StarIcon,
  CORPORATE: Filter5Icon,
  PREMIUMBANK: AccountBalanceIcon,
  APPOINTMENT: PermContactCalendarRoundedIcon,
  EDITOR: BorderColorRoundedIcon,
  MASSIVE_SENDING: SmsIcon,
  SENDS_ANALYSIS: BarChartRoundedIcon,
  PRACTICES: InsertDriveFileIcon,
  USER_MANAGEMENT: ManageAccountsIcon,
  SPOT: TrackChangesRoundedIcon,
  WELCOME: WavingHandRoundedIcon,
  WAVE_MANAGEMENT: ManageHistoryRoundedIcon,
  WAVE: EventRepeatRoundedIcon,
  CAMPAIGNS_MANAGEMENT: CampaignRoundedIcon,
  CONFIGURATIONS: SettingsRoundedIcon,
  ROLES_MANAGEMENT: AttributionRoundedIcon,
  BRANCHES_MANAGEMENT: FactoryRoundedIcon,
  CUSTOMERS_CAMPAIGNS_MANAGEMENT: CampaignRoundedIcon,
  ACTIVITYPROGRESS_MANAGEMENT: StairsRoundedIcon,
};
